export default __webpack_public_path__ + "static/media/404.faba0fe1.svg";